module.exports = __webpack_public_path__ + "static/himmel-und-holle-03-284495368027bdb1471f09f36673f786.jpg";